import React from 'react'
import './school-seo.css'
import Axios from 'axios'
import { baseUrl } from '../assets/Animations'
import AddNewTownPopup from './AddNewTownPopup/AddNewTownPopup'
import { set } from 'date-fns'

const SchoolSEO = () => {

    const [townName, setTownName] = React.useState('')
    const [uri, setURI] = React.useState('')
    const [schoolAbbr, setSchoolAbbr] = React.useState('')
    const [videoURL, setVideoURL] = React.useState('')
    const [instruments, setInstruments] = React.useState([])
    const [schools, setSchools] = React.useState([])
    const [towns, setTowns] = React.useState([])
    const [selectedSchool, setSelectedSchool] = React.useState(false)
    const [selectedTown, setSelectedTown] = React.useState(false)
    const [selectedInst, setSelectedInst] = React.useState(false)
    const [addNewSchool, setAddNewSchool] = React.useState(false)
    const [newInst, setNewInst] = React.useState(false)
    const [addNewTown, setAddNewTown] = React.useState(false)
    const [addNewInstrument, setAddNewInstrument] = React.useState(false)
    const [primeToAddInstToTown, setPrimeToAddInstToTown] = React.useState(false)
    const [primeToAddTownToSchool, setPrimeToAddTownToSchool] = React.useState(false)
    const [primeToAddInstToSchool, setPrimeToAddInstToSchool] = React.useState(false)
    const [deleteTownWarning, setDeleteTownWarning] = React.useState(false)
    const [townInstrumentPages, setTownInstrumentPages] = React.useState([])
    const [updatedTown, setUpdatedTown] = React.useState(false)


    const myToken = localStorage.getItem('token')
    const myHeader = {
        headers: { Authorization: `Bearer ${myToken}` }
    }

    React.useEffect(() => {
        Axios.get(`${baseUrl}/schools`, myHeader)
        .then((res) => setSchools(res.data))
        .catch((err) => console.log(err))

        Axios.get(`${baseUrl}/inst`, myHeader)
        .then((res) => setInstruments(res.data))
        .catch((err) => console.log(err))

        Axios.get(`${baseUrl}/town`, myHeader)
        .then((res) => setTowns(res.data))
        .catch((err) => console.log(err))
        Axios.get(`${baseUrl}/instrument-town-pages`, myHeader)
        .then((res) => setTownInstrumentPages(res.data))
        .catch((err) => console.log(err))
    }, [])


    React.useEffect(() => {
        if(addNewInstrument) {
            setNewInst({
                id: Math.random().toString(16).slice(2),
                name: '',
                uri: '',
                parentInstrument: '',
                instrumentGroup: ''
              })
        }
    }, [addNewInstrument])

const editTownInstrumentPage = (value, id, fieldPath, index) => {
  setUpdatedTown(id);
  setTownInstrumentPages(prevPages =>
    prevPages.map(page => {
      if (page.id !== id) return page;

      // Handle intro/bodyText as arrays with index updates
      if ((fieldPath === "intro" || fieldPath === "bodyText") && index !== undefined) {
        const updatedArr = [...page[fieldPath]];
        updatedArr[index] = { ...updatedArr[index], content: value };
        return { ...page, [fieldPath]: updatedArr };
      }

      const updatedPage = JSON.parse(JSON.stringify(page));

      const keys = fieldPath.split(".");
      let obj = updatedPage;
      for (let i = 0; i < keys.length - 1; i++) {
        obj = obj[keys[i]];
      }
      obj[keys[keys.length - 1]] = value;

      return updatedPage;
    })
  );
};


const pushNewIntroSection = (id) => {
    setUpdatedTown(id)
    setTownInstrumentPages(prevPages =>
        prevPages.map(page => {
            if (page.id === id) {
                const newIntro = {
                    id: Math.random().toString(16).slice(2),
                    content: '',
                };
                return { ...page, intro: [...page.intro, newIntro] };
            }
            return page;
        })
    );
}

    const saveTownInstrumentPage = (id) => {
        const updatedPage = townInstrumentPages.find(page => page.id === id);
        Axios.put(`${baseUrl}/instrument-town-pages/${id}`, updatedPage, myHeader)
        .then((res) => {
            setTownInstrumentPages((prev) => {
                return prev.map((page) => {
                    if (page.id === id) {
                        return { ...page, ...res.data }
                    }
                    return page
                })
            })
            setUpdatedTown(false)
        })
        .catch((err) => console.log(err))
    }

    React.useEffect(() => {
        console.log(townInstrumentPages)
    }, [townInstrumentPages])

    const closeAndUpdateSchool = () => {
        document.body.style.cursor='wait'
        Axios.put(`${baseUrl}/schools`, {
            id: selectedSchool.id,
            schoolAbbreviation: selectedSchool.schoolAbbreviation,
            name: selectedSchool.name,
            towns: selectedSchool.towns,
            about: selectedSchool.about,
            careersPage: selectedSchool.careersPage,
            instruments: selectedSchool.instruments,
            phoneNumber: selectedSchool.phoneNumber,
            city: selectedSchool.city,
            state: selectedSchool.state,
            email: selectedSchool.email,
            logoUrl: selectedSchool.logoUrl,
            favicon: selectedSchool.favicon,
            facebookUrl: selectedSchool.facebookUrl,
            instagramUrl: selectedSchool.instagramUrl,
            faqs: selectedSchool.faqs
        }, myHeader)
        .then((res) => {
            let mySchools = schools
            for(let i = 0; i < mySchools.length; i++) {
                if(mySchools[i].id === res.data.id) {
                    mySchools.splice(i, 1, res.data)
                }
            }
            setSchools([...mySchools])
            setSelectedSchool(false)
            document.body.style.cursor='default'
        })
        .catch((err) => {
            console.log(err)
            document.body.style.cursor='default'
        })
    }

    const closeAndUpdateTown = () => {
        document.body.style.cursor='wait'
        Axios.put(`${baseUrl}/town`, {
            id: selectedTown.id,
            townName: selectedTown.townName,
            townUri: selectedTown.townUri,
            schoolAbbreviation: selectedTown.schoolAbbreviation,
            instruments: selectedTown.instruments
        }, myHeader)
        .then((res) => {
            let myTowns = towns
            for(let i = 0; i < myTowns.length; i++) {
                if(myTowns[i].id === res.data.id) {
                    myTowns.splice(i, 1, res.data)
                }
            }
            setTowns([...myTowns])
            setSelectedTown(false)
            document.body.style.cursor='default'
        })
        .catch((err) => {
            console.log(err)
            document.body.style.cursor='default'
        })
    }

    const closePopup = (tar, typeOfPopup) => {
        if(tar === "school-edit-popup-wrapper") {
            if(typeOfPopup === 'school') {
                if(addNewSchool) {
                    setSelectedSchool(false)
                } else {
                    closeAndUpdateSchool()
                }
            } else if (typeOfPopup === 'town') {
                closeAndUpdateTown()
            } else if (typeOfPopup === 'instrument') {
                setSelectedInst(false)
            } else if (typeOfPopup === 'new-instrument') {
                setAddNewInstrument(false)
            }
        }
    }

    const updateSelectedSchool = (value, key) => {
        setSelectedSchool((prev) => ({...prev, [key]: value}))
    }

    const updateSelectedTown = (value, key) => {
        setSelectedTown((prev) => ({...prev, [key]: value}))
    }

    const removeTownFromSchool = (id) => {
        let mySchool = selectedSchool
        for(let i = 0; i < mySchool.towns.length; i++) {
            if(mySchool.towns[i].id === id) {
                mySchool.towns.splice(i, 1)
            }
        }
        setSelectedSchool({...mySchool})
    }

    const deleteInstrumentFromTown = (instIndex) => {
        let myTown = selectedTown
        myTown.instruments.splice(instIndex, 1)
        setSelectedTown({...myTown})
    }

    const editCopyOfSelectedTown = (instIndex, copyIndex, value) => {
        let myTown = selectedTown
        myTown.instruments[instIndex].copy[copyIndex].text = value
        setSelectedTown({...myTown})
    }

    const deleteCopySectionofSelectedTown = (instIndex, coIndex) => {
        let myTown = selectedTown
        myTown.instruments[instIndex].copy.splice(coIndex, 1)
        setSelectedTown({...myTown})
    }

    const addCopySection = (instIndex) => {
        let myTown = selectedTown
        myTown.instruments[instIndex].copy.push({id: Math.random().toString(16).slice(2), text: ''})
        setSelectedTown({...myTown})
    }

    const addFAQSection = (instIndex) => {
        let myTown = selectedTown
        myTown.instruments[instIndex].faqs.push({id: Math.random().toString(16).slice(2), question: '', answer: ''})
        setSelectedTown({...myTown})
    }
    
    const editQA = (instIndex, qaIndex, key, val) => {
        let myTown = selectedTown
        myTown.instruments[instIndex].faqs[qaIndex][key] = val
        setSelectedTown({...myTown})
    }

    const deleteQASectionFromSelectedTown = (instIndex, qaIndex) => {
        let myTown = selectedTown
        myTown.instruments[instIndex].faqs.splice(qaIndex, 1)
        setSelectedTown({...myTown})
    }

    const findAndSetSelectedInstToAddToTown = (id) => {
        let inst = instruments.find(u => u.id === id);
        let myTown = selectedTown
        myTown.instruments.push({
            id: inst.id,
            name: inst.name,
            uri: inst.uri,
            copy: [{id: Math.random().toString(16).slice(2), text: ''}],
            faqs: [],
            video: {
                name: '',
                description: '',
                thumbnailUrl: '',
                uploadDate: '',
                embedUrl: '',
                hasPart: []
            }
        })
        setSelectedTown({...myTown})
        setPrimeToAddInstToTown(false)
    }
    const findAndSetSelectedTownToAddToSchool = (id) => {
        let myTown = towns.find(u => u.id === id);
        let mySchool = selectedSchool
        mySchool.towns.push({
            id: myTown.id,
            name: myTown.townName,
            uri: myTown.townUri
        })
        setSelectedSchool({...mySchool})
        setPrimeToAddTownToSchool(false)
    }
    const findAndSetSelectedInstToAddToSchool = (id) => {
        let inst = instruments.find(u => u.id === id);
        let mySchool = selectedSchool
        mySchool.instruments.push({
            id: inst.id,
            name: inst.name,
            uri: inst.uri,
            copy: [{id: Math.random().toString(16).slice(2), text: ''}],
            faqs: [],
            video: {
                name: '',
                description: '',
                thumbnailUrl: '',
                uploadDate: '',
                embedUrl: '',
                hasPart: []
            }
        })
        setSelectedSchool({...mySchool})
        setPrimeToAddInstToSchool(false)
    }

    const changeTheVideoUrlForInstrument = (instIndex, val) => {
        let myTown = selectedTown
        myTown.instruments[instIndex].video.embedUrl = val
        setSelectedTown({...myTown})
    }

    const deleteInstrumentFromSchool = (instIndex) => {
        let mySchool = selectedSchool
        mySchool.instruments.splice(instIndex, 1)
        setSelectedSchool({...mySchool})
    }

    const deleteCopyFromInstrumentFromSchool = (instIndex, coIndex) => {
        let mySchool = selectedSchool
        mySchool.instruments[instIndex].copy.splice(coIndex, 1)
        setSelectedSchool({...mySchool})
    }

    const addCopySectionToInstrumentInSchool = (i) => {
        let mySchool = selectedSchool
        mySchool.instruments[i].copy.push({id: Math.random().toString(16).slice(2), text: ''})
        setSelectedSchool({...mySchool})
    }

    const deleteTheTown = (id) => {
        Axios.delete(`${baseUrl}/town/${id}`, myHeader)
        .then((res) => {
            setDeleteTownWarning(false)
            setSelectedTown(false)
            let myTowns = towns
            for(let i = 0; i < myTowns.length; i++) {
                if(myTowns[i].id === res.data.id) {
                    myTowns.splice(i, 1)
                }
            }
            setTowns([...myTowns])
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const beginToAddNewSchool = () => {
        setAddNewSchool(true)
        setSelectedSchool({
            id: '',
            schoolAbbreviation: '',
            name: '',
            towns: [],
            about: [],
            careersPage: {testimonials: []},
            instruments: [],
            phoneNumber: '',
            city: '',
            state: '',
            email: '',
            logoUrl: '',
            favicon: '',
            facebookUrl: '',
            instagramUrl: '',
            faqs: []
        })
    }

    const submitTheNewSchool = () => {
        Axios.post(`${baseUrl}/schools`, {
            newSchool: selectedSchool
        }, myHeader)
        .then((res) => {
            setSchools(prev => [...prev, res.data])
            setSelectedSchool(false)
            addNewSchool(false)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const editSchoolInstrumentCopy = (instIndex, coIndex, val) => {
        let mySchool = selectedSchool
        mySchool.instruments[instIndex].copy[coIndex].text = val
        setSelectedSchool({...mySchool})
    }

    const editFAQofSchool = (faqIndex, key, val) => {
        let mySchool = selectedSchool
        mySchool.faqs[faqIndex][key] = val
        setSelectedSchool({...mySchool})
    }

    const deleteFAQFromSchool = (faqIndex) => {
        let mySchool = selectedSchool
        mySchool.faqs.splice(faqIndex, 1)
        setSelectedSchool({...mySchool})
    }

    const addFAQToSchool = () => {
        let mySchool = selectedSchool
        mySchool.faqs.push({id: Math.random().toString(16).slice(2), question: '', answer: ''})
        setSelectedSchool({...mySchool})
    }

    const editNewInstrument = (val, key) => {
        let myNewInst = newInst
        myNewInst[key] = val
        setNewInst({...myNewInst})
    }

    const addAboutSection = () => {
        let mySchool = selectedSchool
        mySchool.about.push({id: Math.random().toString(16).slice(2), text: ''})
        setSelectedSchool({...mySchool})
    }

    const editAboutSection = (index, val) => {
        let mySchool = selectedSchool
        mySchool.about[index].text = val
        setSelectedSchool({...mySchool})
    }

    const removeTextarea = (index) => {
        let mySchool = selectedSchool
        mySchool.about.splice(index, 1)
        setSelectedSchool({...mySchool})
    }

    const createNewInst = () => {
        Axios.post(`${baseUrl}/inst`, {
            name: newInst.name,
            uri: newInst.uri,
            parentInstrument: newInst.parentInstrument,
            instrumentGroup: newInst.instrumentGroup
        }, myHeader)
        .then((res) => {
            setInstruments((prev) => [...prev, res.data])
            setAddNewInstrument(false)
        })
        .catch((err) => {
            console.log(err)
        })
    }

    const addTestimonial = () => {
        let mySchool = selectedSchool
        if(!mySchool.careersPage) mySchool.careersPage = {testimonials: []}
        mySchool.careersPage.testimonials.push({
            id: Math.random().toString(16).slice(2), 
            teacherName: '', 
            teacherImage: '', 
            quote: '', 
            instruments: '', 
            articleLink: ''
        })
        setSelectedSchool({...mySchool})
    }

    const updateTestimonial = (val, index, key) => {
        let mySchool = selectedSchool
        mySchool.careersPage.testimonials[index][key] = val
        setSelectedSchool({...mySchool})
    }

    const removeTestimonial = (id) => {
        let mySchool = selectedSchool
        for(let i = 0; i < mySchool.careersPage.testimonials.length; i++) {
            if(mySchool.careersPage.testimonials[i].id === id) {
                mySchool.careersPage.testimonials.splice(i, 1)
            }
        }
        setSelectedSchool({...mySchool})
    }
    return(
        <div className='school-seo-wrapper'>
            {addNewTown && <AddNewTownPopup setAddNewTown={setAddNewTown} instruments={instruments} setTowns={setTowns} />}
            {deleteTownWarning &&
                <div className='delete-town-warning-wrapper'>
                    <div className='delete-town-popup'>
                        <h2>Are you sure you want to delete {selectedTown.townName} and all it's copy and FAQs?!?!?</h2>
                        <div onClick={() => deleteTheTown(selectedTown.id)}>yes</div>
                        <div onClick={() => setDeleteTownWarning(false)}>CANCEL</div>
                    </div>
                </div>
            }
            {/* ---------EDIT SCHOOL POPUP-------- */}
            {
                selectedSchool &&
                <div className='school-edit-popup-wrapper' id="school-edit-popup-wrapper" onClick={(e) => closePopup(e.target.id, 'school')}>
                    <div className='school-edit-popup'>
                        {addNewSchool ? <input value={selectedSchool.id} onChange={(e) => updateSelectedSchool(e.target.value, 'id')} /> : <div>{selectedSchool.id}</div>}
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>Name</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.name} onChange={(e) => updateSelectedSchool(e.target.value, 'name')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>School Abbreviation</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.schoolAbbreviation} onChange={(e) => updateSelectedSchool(e.target.value, 'schoolAbbreviation')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>Phone Number</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.phoneNumber} onChange={(e) => updateSelectedSchool(e.target.value, 'phoneNumber')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>Email</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.email} onChange={(e) => updateSelectedSchool(e.target.value, 'email')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>City</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.city} onChange={(e) => updateSelectedSchool(e.target.value, 'city')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>State</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.state} onChange={(e) => updateSelectedSchool(e.target.value, 'state')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>Logo URL</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.logoUrl} onChange={(e) => updateSelectedSchool(e.target.value, 'logoUrl')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>Flavicon</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.favicon} onChange={(e) => updateSelectedSchool(e.target.value, 'favicon')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>Facebook</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.facebookUrl} onChange={(e) => updateSelectedSchool(e.target.value, 'facebookUrl')}/>
                        </div>
                        <div className='school-edit-popup-input__wrapper'>
                            <h5>Instagram</h5>
                            <input className='school-edit-popup-input' value={selectedSchool.instagramUrl} onChange={(e) => updateSelectedSchool(e.target.value, 'instagramUrl')}/>
                        </div>
                        <div className='school-edit-popup__section'>
                            <h3>ABOUT</h3>
                            {selectedSchool.about.map((sec, index) => 
                                <div className='school-edit-popup__text-area__wrapper' id={sec.id}>
                                    <div onClick={() => removeTextarea(index)} className='school-edit-popup__remove-text-area'>x</div>
                                    <textarea className='school-edit-popup__text-area' value={sec.text} onChange={(e) => editAboutSection(index, e.target.value)} />
                                </div>
                            )}
                            <div className='school-edit-popup__add-btn' onClick={() => addAboutSection()}>+ Add Section</div>
                        </div>
                        <div className='school-edit-popup__section'>
                            <h3>AREAS</h3>
                            {selectedSchool.towns.map((town) => 
                                <div className='school-edit-town__wrapper' key={town.id}>
                                    <div className='school-edit-town'>{town.name}</div>
                                    <div className='school-edit-town__x' onClick={() => removeTownFromSchool(town.id)}>x</div>
                                </div>
                            )}
                            {primeToAddTownToSchool && 
                                <div className='school-edit-town__new-town-dropdown__wrapper'>
                                    <select className='school-edit-town__new-town-dropdown' onChange={(e) => findAndSetSelectedTownToAddToSchool(e.target.value)}>
                                        <option value={{}}>NONE</option>
                                        {towns.map((town) => <option key={town.id} value={town.id}>{town.townName}</option>)}
                                    </select>
                                </div>
                            }
                            <div className='school-edit-add-town-button' onClick={() => setPrimeToAddTownToSchool(true)}>+ Add Town</div>
                        </div>
                        <div className='school-edit-popup__section'>
                            <h3>Careers Page</h3>
                            {selectedSchool.careersPage?.testimonials?.map((test, testIndex) =>
                                <div key={test.id} className='school-edit-popup__careers-page'>
                                    <div onClick={() => removeTestimonial(test.id)}>X</div>
                                    <div className='school-edit-popup__careers-page-inputs'><input value={test.teacherName} onChange={(e) => updateTestimonial(e.target.value, testIndex, 'teacherName')} placeholder='Teacher Name' /></div>
                                    <div className='school-edit-popup__careers-page-inputs'><input value={test.teacherImage} onChange={(e) => updateTestimonial(e.target.value, testIndex, 'teacherImage')} placeholder='Teacher Picture Url' /></div>
                                    <div className='school-edit-popup__careers-page-inputs'><textarea value={test.quote} onChange={(e) => updateTestimonial(e.target.value, testIndex, 'quote')} placeholder='Quote' /></div>
                                    <div className='school-edit-popup__careers-page-inputs'><input value={test.instruments} onChange={(e) => updateTestimonial(e.target.value, testIndex, 'instruments')} placeholder='Instruments Seperated by -' /></div>
                                    <div className='school-edit-popup__careers-page-inputs'><input value={test.articleLink} onChange={(e) => updateTestimonial(e.target.value, testIndex, 'articleLink')} placeholder='Link to Article' /></div>
                                </div>
                            )}
                            <div className='school-edit-add-town-button' onClick={() => addTestimonial()}>+ Add Testimonial</div>
                        </div>
                        <div className='school-edit-popup__section'>
                            <h3>INSTRUMENTS</h3>
                            {selectedSchool.instruments.map((inst, instIndex) => 
                                <div className='school-edit-popup__instrument-block' key={inst.id}>
                                    <div className='school-edit-popup__instrument-block__x' onClick={() => deleteInstrumentFromSchool(instIndex)}>X</div>
                                    <h5>{inst.name}</h5>
                                    {inst.copy.map((co, coIndex) => 
                                    <div>
                                        <textarea className='instrument-block__textarea' placeholder='Write here...' key={co.id} value={co.text} onChange={(e) => editSchoolInstrumentCopy(instIndex, coIndex, e.target.value)} />
                                        <div className='instrument-block__textarea__x' onClick={() => deleteCopyFromInstrumentFromSchool(instIndex, coIndex)}>x</div>
                                    </div>
                                    )}
                                    <div className='instrument-block__add-copy-section-btn__wrapper'>
                                        <div className='instrument-block__add-copy-section-btn' onClick={() => addCopySectionToInstrumentInSchool(instIndex)}>+ Add Copy Section</div>
                                    </div>
                                </div>
                            )}
                            {primeToAddInstToSchool &&
                                <select onChange={(e) => findAndSetSelectedInstToAddToSchool(e.target.value)}>
                                    <option value={{}}>NONE</option>
                                    {instruments.map((inst) => <option key={inst.id} value={inst.id}>{inst.name}</option>)}
                                </select>
                            }
                            <div className='school-edit-add-town-button' onClick={() => setPrimeToAddInstToSchool(true)}>+ Add Instrument</div>
                        </div>
                        <div className='school-edit-popup__section'>
                            <h3>FAQs</h3>
                            {selectedSchool.faqs.map((faq, faqIndex) => 
                                <div className='school-edit__faq-wrapper' key={faq.id}>
                                    <div className='school-edit__faq-question__x' onClick={() => deleteFAQFromSchool(faqIndex)}>x</div>
                                    <input className='school-edit__faq-question' placeholder='Question' value={faq.question} onChange={(e) => editFAQofSchool(faqIndex, 'question', e.target.value)} />
                                    <textarea className='school-edit__faq-answer' placeholder='Answer' value={faq.answer} onChange={(e) => editFAQofSchool(faqIndex, 'answer', e.target.value)} />
                                </div>
                            )}
                            <div className='school-edit-add-town-button' onClick={() => addFAQToSchool()}>+ Add FAQ</div>
                        </div>
                        {addNewSchool ? <div className='school-edit-add-town-button' onClick={() => submitTheNewSchool()}>CREATE SCHOOL</div>: null}
                    </div>
                </div>
            }
            {/* -------------------------------- */}

            {/* ---------EDIT TOWN POPUP-------- */}
            {
                selectedTown &&
                <div className='school-edit-popup-wrapper' id="school-edit-popup-wrapper" onClick={(e) => closePopup(e.target.id, 'town')}>
                    <div className='school-edit-popup'>
                        <div className='school-edit-popup__town-popup'>
                            <h5>Id</h5>
                            <div className='town-popup__input'>{selectedTown.id}</div>
                        </div>
                        <div className='school-edit-popup__town-popup'>
                            <h5>Town Name</h5>
                            <input className='town-popup__input' value={selectedTown.townName} onChange={(e) => updateSelectedTown(e.target.value, 'townName')}/>
                        </div>
                        <div className='school-edit-popup__town-popup'>
                            <h5>URI</h5>
                            <input className='town-popup__input' value={selectedTown.townUri} onChange={(e) => updateSelectedTown(e.target.value, 'townUri')}/>
                        </div>
                        <div className='school-edit-popup__town-popup'>
                            <h5>School Abbreviation</h5>
                            <input className='town-popup__input' value={selectedTown.schoolAbbreviation} onChange={(e) => updateSelectedTown(e.target.value, 'schoolAbbreviation')}/>
                        </div>
                        <div className='town-popup__sections'>
                            <h3>Instruments</h3>
                            {selectedTown.instruments.map((inst, instIndex) => 
                                <div className='town-popup__each-instrument' key={inst.id}>
                                    <div className='town-popup__delete-instrument' onClick={() => deleteInstrumentFromTown(instIndex)}>X</div>
                                    <h5>{inst.name} Copy</h5>
                                    <div>
                                        <input placeholder='video url for instrument' value={inst.video.embedUrl} onChange={(e) => changeTheVideoUrlForInstrument(instIndex, e.target.value)}/>
                                    </div>
                                    {inst.copy.map((co, coIndex) => 
                                        <div key={co.id}>
                                            <textarea className='each-instrument__textarea' value={co.text} onChange={(e) => editCopyOfSelectedTown(instIndex, coIndex, e.target.value)}/>
                                            <div className='each-instrument__textarea__x' onClick={() => deleteCopySectionofSelectedTown(instIndex, coIndex)}>x</div>
                                        </div>
                                    )}
                                    <div className='each-instrument__add-copy-section' onClick={() => addCopySection(instIndex)}>+ Add Copy Section</div>
                                    <h5>{inst.name} FAQs</h5>
                                    {inst.faqs.map((qa, qaIndex) => 
                                        <div className='each-instrument__each-faq-section' key={qa.id}>
                                            <input className='each-instrument__question' value={qa.question} placeholder='Question' onChange={(e) => editQA(instIndex, qaIndex, 'question', e.target.value)} />
                                            <div className='each-instrument__answer__x' onClick={() => deleteQASectionFromSelectedTown(instIndex, qaIndex)}>x</div>
                                            <textarea className='each-instrument__answer' value={qa.answer} placeholder='Answer' onChange={(e) => editQA(instIndex, qaIndex, 'answer', e.target.value)} />
                                        </div>
                                    )}
                                    <div className='each-instrument__add-copy-section' onClick={() => addFAQSection(instIndex)}>+Add FAQ Section</div>
                                </div>
                            )}
                            {primeToAddInstToTown && 
                                <select onChange={(e) => findAndSetSelectedInstToAddToTown(e.target.value)}>
                                    <option value={{}}>NONE</option>
                                    {instruments.map((inst) => <option key={inst.id} value={inst.id}>{inst.name}</option>)}
                                </select>
                            }
                            <div className='school-edit-add-town-button' onClick={() => setPrimeToAddInstToTown(true)}>+ Add Instrument</div>
                        </div>
                        <div className='delete-town-btn' onClick={() => setDeleteTownWarning(true)}>DELETE TOWN!</div>
                    </div>
                </div>
            }
            {/* -------------------------------- */}

            {/* ---------EDIT INSTRUMENT POPUP-------- */}
            {
                selectedInst &&
                <div className='school-edit-popup-wrapper' id="school-edit-popup-wrapper" onClick={(e) => closePopup(e.target.id, 'instrument')}>
                    <div className='school-edit-popup'>
                        <div>{selectedInst.id}</div>
                        <div>{selectedInst.name}</div>
                        <div>{selectedInst.uri}</div>
                        <div>{selectedInst.parentInstrument}</div>
                        <div>{selectedInst.instrumentGroup}</div>
                    </div>
                </div>
            }
            {/* -------------------------------- */}

            {/* --------------CREATE INSTRUMENT POPUP------------------ */}
            {
                addNewInstrument &&
                <div className='school-edit-popup-wrapper' id="school-edit-popup-wrapper" onClick={(e) => closePopup(e.target.id, 'new-instrument')}>
                    <div className='school-edit-popup'>
                        <input placeholder='name' onChange={(e) => editNewInstrument(e.target.value, 'name')} value={newInst.name} />
                        <input placeholder='uri' onChange={(e) => editNewInstrument(e.target.value, 'uri')} value={newInst.uri} />
                        <input placeholder='parent instrument' onChange={(e) => editNewInstrument(e.target.value, 'parentInstrument')} value={newInst.parentInstrument} />
                        <input placeholder='instrument group' onChange={(e) => editNewInstrument(e.target.value, 'instrumentGroup')} value={newInst.instrumentGroup} />
                        <div className='school-edit-add-town-button' onClick={() => createNewInst()}>Add Instrument</div>
                    </div>
                </div>
            }

            {/* -------------------------------- */}
            
            <div className='school-seo-schools-sections'>
                <div className='schools-sections__top-wrapper'>
                    <h4>Schools</h4>
                </div>
                <div className='schools-sections__scroll-area'>
                    {schools.map((school) => 
                        <div key={school.id}>
                            <h5 className='school-seo-school' onClick={() => setSelectedSchool(school)}>{school.name}</h5>
                        </div>
                    )}
                </div>
                <div className='school-seo-add-btn__wrapper'>
                    <div className='school-seo-add-btn' onClick={() => beginToAddNewSchool()}>Add New School</div>
                </div>
            </div>
            <div className='school-seo-schools-sections'>
                <div className='schools-sections__top-wrapper'>
                    <h4>Towns</h4>
                </div>
                <div className='schools-sections__scroll-area'>
                    {towns.map((town) => 
                        <div  key={town.id}>
                            <h5 className='school-seo-school' onClick={() => setSelectedTown(town)}>{town.townName}</h5>
                        </div>
                    )}
                </div>
                <div className='school-seo-add-btn__wrapper'>
                    <div className='school-seo-add-btn' onClick={() => setAddNewTown(true)}>Add New Town</div>
                </div>
            </div>
            <div className='school-seo-schools-sections'>
                <div className='schools-sections__top-wrapper'>
                    <h4>Instruments</h4>
                </div>
                <div className='schools-sections__scroll-area'>
                    {instruments.map((inst) => 
                        <div key={inst.id}>
                            <h5 className='school-seo-school' onClick={() => setSelectedInst(inst)}>{inst.name}</h5>
                        </div>
                    )}
                    <div className='school-seo-add-btn__wrapper'>
                        <div className='school-seo-add-btn' onClick={() => setAddNewInstrument(true)}>Add New Instrument</div>
                    </div>
                </div>
                {/* <h5 className='school-seo-add-btn' onClick={() => setAddNewInst(true)}>Add New Instrument</h5> */}
            </div>
            <div>{
                townInstrumentPages.map((page) => <div className='town-page__wrapper' key={page.id}>
                    <div>{page.instrument} in {page.town}</div>
                    <input className='town-page__input' onChange={(e) => editTownInstrumentPage(e.target.value, page.id, 'slug')} value={page.slug} />
                    <input className='town-page__input' onChange={(e) => editTownInstrumentPage(e.target.value, page.id, 'artistQuote.text')} value={page.artistQuote.text} />
                    <input className='town-page__input' onChange={(e) => editTownInstrumentPage(e.target.value, page.id, 'artistQuote.author')} value={page.artistQuote.author} />
                    <input className='town-page__input' onChange={(e) => editTownInstrumentPage(e.target.value, page.id, 'artistImage')} value={page.artistImage} />
                    <div>{page.intro.map((intro, index) => <textarea className='town-page__text-input' key={index} onChange={(e) => editTownInstrumentPage(e.target.value, page.id, 'intro', index)} value={intro.content} />)}</div>
                    <div style={{border: "1px solid grey", padding: "3px", borderRadius: "5px", textAlign: "center", backgroundColor: "orange", marginBottom: "20px"}} onClick={() => pushNewIntroSection(page.id)}>Push New Intro</div>
                    <div>Body</div>
                    <div>{page.bodyText.map((body, index) => <textarea className='town-page__text-input' key={index} onChange={(e) => editTownInstrumentPage(e.target.value, page.id, 'bodyText', index)} value={body.content} />)}</div>
                    <div>{page.intro.length < 2 && <div style={{ backgroundColor: 'orange' }}>
                        <div onClick={() => pushNewIntroSection(page.id)}>Push New Intro</div>
                    </div>}</div>
                    {updatedTown && <div onClick={() => saveTownInstrumentPage(page.id)}>Save</div>}
                    </div>)
            }</div>
        </div>
    )
}
export default SchoolSEO